export default "__VITE_ASSET__61831cad__"